export const LocationCheckBoxTypes = {
  ACTIVE: 'Aktiivinen',
  ALL: 'Kaikki',
  ARCHIVED: 'Arkistoitu',
  INACTIVE: 'Ei aktiivinen',
  PICKUP: 'Noudettavissa',
}
